import React from "react";
import PropTypes from "prop-types";
import SidePanel from "components/sidePanel";
import { useTranslation } from "react-i18next";

function TaskBriefPanel({ isOpen, onClose, brief = "", deadline }) {
  const dt = deadline ? new Date(deadline) : null;
  const dateStr = dt
    ? dt.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : null;
  const showTime = typeof deadline === "string" && deadline.length > 10;
  const timeStr =
    dt && showTime
      ? dt.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : null;

  const [t] = useTranslation();

  return (
    <SidePanel
      isOpen={isOpen}
      onClose={onClose}
      title={t("briefTitle")}
      width={354}
    >
      <div className="py-[20px] px-[24px] flex flex-col gap-[16px] flex-1 self-stretch">
        <div className="flex flex-col gap-[10px] self-stretch ">
          <div className="flex py-[4px] px-[10px] items-center gap-[10px] self-stretch rounded-[4px] bg-[#F7F8F8]">
            <div className="text-[#1D1B22] font-semibold text-[16px]">
              {t("taskBriefTitle")}
            </div>
          </div>
          <div className="text-[#1D1B22] text-[16px] font-regular">
            {brief || "-"}
          </div>
          {(dateStr || timeStr) && (
            <div className="text-[#51525C] text-[12px] font-regular">
              {dateStr}
              {timeStr ? ` - ${timeStr}` : ""}
            </div>
          )}
        </div>
      </div>
    </SidePanel>
  );
}

TaskBriefPanel.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  brief: PropTypes.string,
  deadline: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
};

export default TaskBriefPanel;
